import API from '@/api/index';
import * as Auth from '@/utils/auth';

const vehicle = {
  state: {
    vehicles: Auth.getStoreVehicles() || [],
    selectedVehicle: null,
    lastWaypointUpdateTime: 0,
    utcTicks: 0
  },

  mutations: {
    SET_VEHICLES: (state, vehicles) => {
      // if (state.vehicles.length > 0 && vehicles.length > 0 && state.vehicles.length === vehicles.length) {
      //   vehicles.map(item => {
      //     let v = state.vehicles.filter(b => b.id === item.id)[0];
      //     if (v) {
      //       let backup = Object.assign({}, v);
      //       v = item;
      //       v.waypoint = backup.waypoint;
      //     }
      //     return 0;
      //   });
      // }
      // else {
      //   state.vehicles = vehicles;
      // }
      state.vehicles = vehicles;
      if (state.selectedVehicle === null) {
        state.selectedVehicle = state.vehicles[0];
      }
    },
    SET_SELECTED_VEHICLES: (state, selectedVehicle) => {
      state.selectedVehicle = selectedVehicle;
    },
    SET_VEHICLES_WAYPOINTS: (state, waypoints) => {
      waypoints.forEach(wp => {
        let vehicleId = wp.vehicleId;
        let vehicle = state.vehicles.filter(v => v.id === vehicleId)[0];
        if (vehicle != null) {
          vehicle.waypoint = wp;
        }
        // if (wp.utcTicks > state.utcTicks) {
        //   if (state.utcTicks < 10) {
        //     state.utcTicks++;
        //   }
        //   else { state.utcTicks = wp.utcTicks }
        // }
      });
      // if (waypoints.length > 0) {  }
      state.lastWaypointUpdateTime = new Date();
      Auth.setStoreVehicles(state.vehicles);
    },
    RESET_UTC_TICKS: (state) => {
      state.utcTicks = 0;
    },
    SET_WP_UPDATE_TIME: (state) => {
      state.lastWaypointUpdateTime = new Date();
    },
    UPDATE_VEHICLE: (state, model) => {
      let v = state.vehicles.filter(a => a.id === model.id)[0];
      if (v) {
        v.plate = model.plate;
        v.simPhone = model.simPhone;
        v.vehicleBrand = model.vehicleBrand;
        v.vehicleType = model.vehicleType;
      }
    },
    CREATE_VEHICLE: (state, model) => {
      state.vehicles.push(model);
    },
  },

  actions: {
    getVehicles ({ commit }) {
      return new Promise((resolve, reject) => {
        API.vehicle.getVehicles().then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            commit('SET_VEHICLES', result.data);
            resolve(result.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    createVehicle ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.vehicle.createVehicle(data).then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            resolve(result.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    checkImei ({ state }, imei) {
      return new Promise((resolve, reject) => {
        API.device
          .checkImei(imei)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              resolve(result.data);
            } else {
              reject(result);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    updateVehicle ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.vehicle.updateVehicle(data).then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            resolve(result.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    deleteVehicle ({ commit }, vehicleId) {
      return new Promise((resolve, reject) => {
        API.vehicle.deleteVehicle(vehicleId).then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            resolve(result.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    getVehicleWaypoints ({ state, commit }) {
      return new Promise((resolve, reject) => {
        API.vehicle.getVehicleWaypoints(state.utcTicks).then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            commit('SET_VEHICLES_WAYPOINTS', result.data);
            resolve(result.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
          console.log('getVehicleWaypoints -> error', error);
        });
      });
    },

    turnOnSecurity ({ commit }, vehicleId) {
      let data = {
        vehicleId: vehicleId,
        command: 'lock'
      };
      return new Promise((resolve, reject) => {
        API.vehicle.sendCommandToDeviceByEnum(data).then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            resolve(result.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    turnOffSecurity ({ commit }, vehicleId) {
      let data = {
        vehicleId: vehicleId,
        command: 'unlock'
      };
      return new Promise((resolve, reject) => {
        API.vehicle.sendCommandToDeviceByEnum(data).then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            resolve(result.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    turnOffEngine ({ commit }, vehicleId) {
      return new Promise((resolve, reject) => {
        API.vehicle.turnOffEngine(vehicleId).then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            resolve(result.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    restoreEngine ({ commit }, vehicleId) {
      return new Promise((resolve, reject) => {
        API.vehicle.restoreEngine(vehicleId).then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            resolve(result.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    rebootDevice ({ commit }, vehicleId) {
      let data = {
        vehicleId,
      };
      return new Promise((resolve, reject) => {
        API.vehicle.rebootDevice(data).then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            resolve(result.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    getSecurityConfig ({ commit }, vehicleId) {
      return new Promise((resolve, reject) => {
        API.vehicle.getSecurityConfig(vehicleId).then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            resolve(result.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    updateSecurityConfig ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.vehicle.updateSecurityConfig(data).then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            resolve(result.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    shareLocation ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.vehicle.shareLocation(data).then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            resolve(result.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    checkSharingCode ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.vehicle.checkSharingCode(data).then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            resolve(result.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    getSharingStates ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.vehicle.getSharingStates(data).then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            resolve(result.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    stopSharingLocation ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.vehicle.stopSharingLocation(data).then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            resolve(result.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    intervalSendData ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.vehicle.intervalSendData(data).then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            resolve(result.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    updateCutOffEngine ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.vehicle.updateCutOffEngine(data).then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            resolve(result.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    updateLastWaypoint ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.vehicle.updateLastWaypoint(data).then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            resolve(result.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },
  }
};

export default vehicle;



// WEBPACK FOOTER //
// ./src/store/modules/vehicle.js